import { fromJS } from 'immutable';
import * as ACTIONS from  '../containers/constants';

const initialState = fromJS({});

export function infodexGroupsReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.CRYODEX_INFODEX_GROUPS_CREATE:
        return {
        ...state,
        data: action.payload,
        };
    case ACTIONS.CRYODEX_INFODEX_GROUPS_GET:
        return {
        ...state,
        data: action.payload,
        };
    case ACTIONS.CRYODEX_INFODEX_GROUPS_UPDATE:
        return {
			...state,data: action.payload,
        };
    default:
      return state;
  }
}

export default infodexGroupsReducer;
